import React from 'react';
import {
  Tabs as MuiTabs,
  TabsProps as MuiTabsProps,
  TabsTypeMap as MuiTabsTypeMap,
} from '@mui/material';
import { DistributiveOmit } from '@mui/types';
import {
  OverrideProps,
  OverridableComponent,
} from '@mui/material/OverridableComponent';

/**
 * Props that we do not want to include with Tabs.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
type TabsBlockedProps = keyof Pick<
  MuiTabsProps,
  'indicatorColor' | 'textColor'
>;
/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system. Use `TabContext` instead.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export interface TabsTypeMap<
  // eslint-disable-next-line @typescript-eslint/ban-types
  AdditionalProps = {},
  RootComponent extends React.ElementType = MuiTabsTypeMap['defaultComponent']
> {
  props: AdditionalProps & DistributiveOmit<MuiTabsProps, TabsBlockedProps>;
  defaultComponent: RootComponent;
}

/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system. Use `TabContext` instead.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export type TabsProps<
  // eslint-disable-next-line deprecation/deprecation
  RootComponent extends React.ElementType = TabsTypeMap['defaultComponent'],
  // eslint-disable-next-line @typescript-eslint/ban-types
  AdditionalProps = {}
> = OverrideProps<
  // eslint-disable-next-line deprecation/deprecation
  TabsTypeMap<AdditionalProps, RootComponent>,
  RootComponent
> & {
  component?: React.ElementType;
};

/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system. Use `TabContext` instead.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
// eslint-disable-next-line deprecation/deprecation
export const Tabs: OverridableComponent<TabsTypeMap> = MuiTabs;
